const EventSearchView = () => import(/* webpackChunkName: "es" */'@/views/EventSearchView');
const EventSingleView = () => import(/* webpackChunkName: "ess" */'@/views/EventSingleView.js');
import makeSingleMapSightRoute from '../utils/createSingleMapSightRoute';
import axios from 'axios';

const eventSightMapRouter = [
  makeSingleMapSightRoute({
    sightMapType: 'event',
    category: 'event',
    path: 'events/whatson',
    route: {
      path: '',
      name: `event-search`,
      component: EventSearchView
    }
  }),
  makeSingleMapSightRoute({
    sightMapType: 'event',
    category: 'event',
    path: 'events/whatson/:entity',
    route: {
      path: '',
      name: `event-single-whatson`,
      meta: { mapPageType: 'event_detail' },
      component: EventSingleView
    }
  }),
  makeSingleMapSightRoute({
    sightMapType: 'event',
    category: 'event',
    path: 'events/calendar/:entity',
    route: {
      path: '',
      name: `event-single-calendar`,
      meta: { mapPageType: 'event_detail' },
      component: EventSingleView,
      beforeEnter(to, from, next) {
        const entity = to.params.entity;
        if (entity) {
          return axios.get(encodeURI(`/api/enf/calendar/${entity}`))
            .then((res) => {
              const detail = res.data || {};
              if (detail.link) {
                if (typeof window !== 'undefined') {
                  window.location.href = detail.link;
                } else {
                  next({ path: 'redirecting', query: { to: detail.link } });
                }
              } else {
                next();
              }
            }).catch(err => {
              console.log(err);
              next();
            });   
        }
        next();
      }
    }
  })
];

export default eventSightMapRouter;
